import React from 'react'

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';

import { FormControl } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

const styles = (theme: Theme) => ({
  searchInput: {
      width: '500px',
      maxWidth: '100%',
      borderRadius: '40px'
  },
  input: {
    fontStyle: 'italic',
    "&::placeholder": {
      fontStyle: 'italic'
    }
  }
});

interface Props {
  imagePath: string;
  handleImage: (event: React.ChangeEvent<HTMLInputElement>) => void,
  getColors: (colors: any) => void,
}

interface State {
}

type PropsWithStyles = Props & WithStyles<'searchInput' | 'input'>;

class SearchInput extends React.Component<PropsWithStyles, State> {

  render() {
    const { classes } = this.props;
    return (  
      <div>
        <FormControl 
            fullWidth 
            margin="normal"
        >
            <TextField
                id="s-input"
                label="Or type an image url (http://...)"
                name="search-input"
                value={this.props.imagePath}
                variant="outlined"
                fullWidth={true}
                margin="normal"
                onChange={this.props.handleImage}
                InputProps={{
                  classes: {
                    root: classes.searchInput,
                    input: classes.input
                  }
                }}
            />
        </FormControl>
      </div>
    );
  }

  }

  export default withStyles(styles)(SearchInput);
